import { Component, OnInit } from '@angular/core';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { AddInstitutionDialogComponent } from '../add-institution-dialog/add-institution-dialog.component';
import { OnlineCampaignComponent } from '../online-campaign/online-campaign.component';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-college',
  templateUrl: './college.component.html',
  styleUrls: ['./college.component.scss']
})
export class CollegeComponent implements OnInit {

  collegeCards =[];
  type:String = "";
  breadcrumb:String = "";

  constructor(
    private campaign : CampaignService,
    public dialog: MatDialog,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.type = this.route.snapshot.paramMap.get('type');
    
    if(this.type == 'c'){
      this.breadcrumb = "College";
      this.getCollegeCards("COLLEGE");
    }else if(this.type == 'i'){
      this.breadcrumb = "Training Institute";
      this.getCollegeCards("TRAINING_INSTITUTE");
    }
  }

  getCollegeCards(campaignType:String): void {
      this.campaign.getListData(campaignType)
      .subscribe(response =>{
     //   console.log(response);
        this.collegeCards = (response as any).data;
      });
  }

  openAddInstitutions() : void {
    const dialogRef = this.dialog.open(AddInstitutionDialogComponent, {
      width: '700px',
      height: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == "Added"){
        this.ngOnInit();
      }
    });
  }

  openOnlineCampaign() : void {
    const dialogRef = this.dialog.open(OnlineCampaignComponent, {
      width: '1041.33px'
    })

    dialogRef.afterClosed().subscribe(response =>{
      if(response == "Added"){
        this.ngOnInit();
      }
    });
  }
}
